import { CanvasController, EditableProperty, Undo } from "../internal"

export class MathJaxProperty extends EditableProperty<string> {
	private input: HTMLInputElement

	public constructor(initialValue?: string, tooltip = "", id: string = "") {
		super(initialValue ?? "", tooltip, id)
	}

	public eq(first: string, second: string): boolean {
		return first == second
	}
	public buildHTML(): HTMLElement {
		let row = this.getRow()

		let col = document.createElement("div") as HTMLDivElement
		col.classList.add("col", "col-md-12", "col-xxl", "my-0", "input-group")
		{
			let formulaSpan1 = document.createElement("span") as HTMLSpanElement
			formulaSpan1.classList.add("input-group-text")
			formulaSpan1.innerHTML = "$"
			col.appendChild(formulaSpan1)

			this.input = document.createElement("input") as HTMLInputElement
			this.input.classList.add("form-control")
			this.input.type = "text"
			this.input.value = this.value ?? ""
			col.appendChild(this.input)

			let formulaSpan2 = document.createElement("div") as HTMLDivElement
			formulaSpan2.classList.add("input-group-text")
			formulaSpan2.innerHTML = "$"
			col.appendChild(formulaSpan2)

			let previousState = ""
			this.input.addEventListener("focusin", (ev) => {
				previousState = this.value ?? ""
			})
			this.input.addEventListener("input", (ev) => {
				this.updateValue(this.input.value)
			})

			this.input.addEventListener("focusout", (ev) => {
				if (this.value && previousState !== this.value) {
					Undo.addState()
				}
			})
			this.input.addEventListener("mousedown", (ev) => {
				CanvasController.instance.draggingFromInput = this.input
			})
		}
		row.appendChild(col)
		return row
	}

	protected disable(disabled = true): void {
		this.input.disabled = disabled
	}
	public updateHTML(): void {
		if (this.input) {
			this.input.value = this.value
		}
	}

	public getMultiEditVersion(properties: MathJaxProperty[]): MathJaxProperty {
		let allEqual = this.equivalent(properties)

		const result = new MathJaxProperty(allEqual ? properties[0].value : "*", this.tooltip, this.id)

		result.addChangeListener((ev) => {
			for (const property of properties) {
				property.updateValue(ev.value, true, true)
			}
		})
		result.getHTMLElement()
		return result
	}
}
